/*
 * View for AttributeInfo
 */

define(["marionette", "./template/attributeInfoTemplate.html"], function (
  Marionette,
  AttributeInfoTemplate,
) {
  var AttributeInfoView = {};

  AttributeInfoView.attributeInfoLayout = Marionette.Layout.extend({
    template: AttributeInfoTemplate,
    regions: {
      attributeValue: "#attributeValue",
    },
  });

  return AttributeInfoView;
});
